interface Props {
  count: number;
  className?: string;
  /** "inverted" = vit bakgrund med blå text (för blå ytbor, t.ex. plusknappen). */
  variant?: "default" | "inverted";
}

/** Blå cirkel med antal olästa notiser. */
export const NotificationDot = ({ count, className = "", variant = "default" }: Props) => {
  if (count <= 0) return null;
  return (
    <span
      className={`inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full px-1.5 text-[11px] font-bold leading-none ${
        variant === "inverted"
          ? "bg-background text-primary border border-primary"
          : "bg-primary text-primary-foreground"
      } ${className}`}
      aria-label={`${count} ${count === 1 ? "ny händelse" : "nya händelser"}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};
